export default "__VITE_ASSET__BaSuF7$F__"